export class SocialMediaModel {
  value: string;
  type: string;

  constructor(value?: string, type?: string) {
    this.value = value;
    this.type = type;
  }
}
